import { BaseTable, Text } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';
import { IDealDetails, IGroupNCI, IKpiTableData, IKpiModal } from '../../../../types/types';
import { getKpiTableData, setColorByValueForKpiCard } from '../DealDetailFunctions';
import { FOOT_NOTE } from '../../../../api/constants';
import { FooterContent } from '../../AllDeals.style';
import { useEffect } from 'react';

// Helper function to normalize EVP name for comparison
const normalizeEvpName = (evpName: string): string => {
  return evpName.toLowerCase().replace(/[^a-z0-9]/g, '');
};

const Container = styled.div`
  overflow: scroll;
  margin-top: 10px;
`;

const ModalKpiTable = (props: {
  dealDetailsData: IDealDetails[];
  years: string[];
  netCarbonIntensityData: IGroupNCI[];
  kpiTableData?: IKpiModal[];
}) => {
  const { dealDetailsData, years, netCarbonIntensityData, kpiTableData } = props;
  
  // Check EVP type for footnote visibility
  const evpName = dealDetailsData[0]?.EVP_NAME ?? '';
  const normalizedEvp = normalizeEvpName(evpName);
  const isTSProducts = normalizedEvp === 'tsproducts';
  const isSLMT = normalizedEvp === 'slmt';
  const shouldShowFootnote = !isTSProducts && !isSLMT;

  const Cols = ['KPI', ...years, 'Total'].map((val) => {
    return {
      accessorKey: val,
      header: val,
    };
  });
  const data = (kpiTableData || getKpiTableData(dealDetailsData, Cols, netCarbonIntensityData)) as IKpiTableData[];
  useEffect(() => {
    const timeout = setTimeout(() => {
      setColorByValueForKpiCard(data.length - 1, 'kpi-table');
    }, 0); // Delay of 0ms ensures it runs after the DOM is updated

    return () => clearTimeout(timeout); // Cleanup timeout
  }, [data]);
  return (
    <Container>
      <BaseTable
        className='kpi-table'
        data-testid='kpi_table'
        style={{ width: '100%' }}
        size='small'
        noFooter
        maxHeight={1000}
        columns={Cols}
        data={data}
      />
      {/* Hide footnote for T&S Products and SLMT EVPs */}
      {shouldShowFootnote && (
        <Text size='small'>
          <FooterContent>
            <em>{FOOT_NOTE}</em>
          </FooterContent>
        </Text>
      )}
    </Container>
  );
};

export default ModalKpiTable;
